import React from 'react';
import { Select, Form } from 'antd';
import transportFieldsConnect from '../../../common/hoc/transportFieldsConnect';
const Option = Select.Option;
const TintsTypes = ({ form, tintsTypes }) => {
  const { getFieldDecorator } = form;
  return (
    <Form.Item label="Тонировка стекол">
      {getFieldDecorator('tint_key')(
        <Select
          style={{ width: '100%' }}
          allowClear={true}
          className="ui-select"
          mode="multiple"
          placeholder="Выберите опции"
          dropdownClassName="ui-select__dropdown-multiple"
          showArrow={true}
          maxTagCount={0}
          getPopupContainer={trigger => trigger.parentNode}
        >
          {tintsTypes &&
            tintsTypes.map(type => (
              <Option
                key={type.tintKey}
                value={type.tintKey}
                label={type.tintName}
              >
                {type.tintName}
              </Option>
            ))}
        </Select>
      )}
    </Form.Item>
  );
};

export default transportFieldsConnect(TintsTypes, ['tintsTypes']);
